import { APP_NAME } from '@trips/shared/config';
import type { ReactNode } from 'react';
import { now } from '../../lib/clock';
import { Icon } from '../../ui/Icon';
import { SkyCard } from '../../ui/Sky';
import s from './Auth.module.css';

/** Sign-in, setup and pairing share one calm screen: the sky over home, then a card. */
export function AuthLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <SkyCard place={{ lat: 26.54, lon: -81.76 }} at={now()} className={s.sky}>
      <div className={s.wrap}>
        <div className={s.brand}>
          <Icon name="airplane-tilt-fill" size={26} />
          <span className="t-title3">{APP_NAME}</span>
        </div>
        <div className={s.card}>
          <h1 className="t-title2">{title}</h1>
          {children}
        </div>
      </div>
    </SkyCard>
  );
}
